// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer{
    margin-top:60px;

    background:#1b5e20;

    color:white;

    text-align:center;

    padding:25px;

    display:flex;
    flex-direction:column;
    gap:8px;
}

.footer p{
    margin:0;
    opacity:.9;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,eAAe;;IAEf,kBAAkB;;IAElB,WAAW;;IAEX,iBAAiB;;IAEjB,YAAY;;IAEZ,YAAY;IACZ,qBAAqB;IACrB,OAAO;AACX;;AAEA;IACI,QAAQ;IACR,UAAU;AACd","sourcesContent":[".footer{\n    margin-top:60px;\n\n    background:#1b5e20;\n\n    color:white;\n\n    text-align:center;\n\n    padding:25px;\n\n    display:flex;\n    flex-direction:column;\n    gap:8px;\n}\n\n.footer p{\n    margin:0;\n    opacity:.9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
